import { render, staticRenderFns } from "./df-recipe-products.vue?vue&type=template&id=3f4d1b85&"
import script from "./df-recipe-products.ts?vue&type=script&lang=js&"
export * from "./df-recipe-products.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports